<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="98px">
      <el-form-item label="任务开始时间" prop="taskStartTime">
        <el-date-picker clearable
                        v-model="queryParams.taskStartTime"
                        type="datetime"
                        value-format="yyyy-MM-dd hh:mm:ss"
                        placeholder="请选择任务开始时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="任务结束时间" prop="taskEndTime">
        <el-date-picker clearable
                        v-model="queryParams.taskEndTime"
                        type="datetime"
                        value-format="yyyy-MM-dd hh:mm:ss"
                        placeholder="请选择任务结束时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="content">
      <el-table
          :data="taskList"
          :header-cell-style="{ background: 'rgb(250,250,250)' }"
          style="width: 100%">
        <el-table-column type="selection" width="55" align="center"/>
        <el-table-column label="任务名称" align="center" prop="taskName"/>
        <el-table-column label="任务开始时间" align="center" prop="taskStartTime" width="180" type="datetime">
          <template slot-scope="{row}">
            <span v-if="row.taskStartTime">{{ row.taskStartTime | timeFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="任务结束时间" align="center" prop="taskEndTime" type="datetime" width="180">
          <template slot-scope="{row}">
            <span v-if="row.taskEndTime">{{ row.taskEndTime | timeFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="任务类型" align="center" prop="taskTypeName"/>
        <el-table-column label="任务描述" align="center" prop="taskContent"/>
        <el-table-column label="创建人" align="center" prop="creator"/>
        <el-table-column label="记录状态" align="center" prop="deleted">
          <template slot-scope="{ row }">
            {{ row.deleted == 0 ? '正常' : '已删除' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="handleUpdate(scope.row)">查看检查项
            </el-button>
            <el-col :span="1.5">
              <el-button
                  type="primary"
                  plain
                  icon="el-icon-plus"
                  size="mini"
                  @click="handleAddRecord(scope.row)">创建专项检查情况记录</el-button>
            </el-col>
          </template>
        </el-table-column>
      </el-table>

<!--      <div style="text-align: right; margin-top: 15px">
        <Page :total="total" :current="curPage" :page-size="pageSize" @on-change="pageChange"/>
      </div>-->
    </div>


    <!-- 添加或修改检查任务对话框 -->
    <el-dialog :title="title" :visible.sync="open1" width="1500px" append-to-body>
      <el-table
          :data="itemList"
          :header-cell-style="{ background: 'rgb(250,250,250)' }"
          style="width: 100%">
        <el-table-column type="selection" width="55" align="center"/>
        <el-table-column label="检查序号" align="center" prop="checkName"/>
        <el-table-column label="适用场合" align="center" prop="applicablePlace"/>
        <el-table-column label="检查依据" align="center" prop="checkBasis" />
        <el-table-column label="检查内容" align="center" prop="checkContent" />
        <el-table-column label="检查方式" align="center" prop="checkWay"/>
        <el-table-column label="创建时间" align="center" prop="createTime"/>
        <el-table-column label="创建人" align="center" prop="creator"/>
        <el-table-column label="记录状态" align="center" prop="deleted">
          <template slot-scope="{ row }">
            {{ row.deleted == 0 ? '正常' : '已删除' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="handleCheckscore(scope.row)">查看评分细则
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :title="title" :visible.sync="open2" width="1000px">
      <el-table
          :data="scoreList"
          :header-cell-style="{ background: 'rgb(250,250,250)' }"
          style="width: 100%">
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column label="是否为否决项" align="center" prop="isReject" >
          <template slot-scope="{ row }">
            {{ row.isReject === 0 ? '否' : '是' }}
          </template>
        </el-table-column>
        <el-table-column label="扣分分值" align="center" prop="deductPoint" />
        <el-table-column label="扣分说明" align="center" prop="deductIllustrate" />
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="addSpecialDanger(scope.row)">创建专项检查隐患治理
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :title="title" :visible.sync="addRecordFrom" width="800px" append-to-body>
      <el-form ref="form" :model="recordForm" :rules="rules" label-width="130px">
        <el-form-item label="重大危险源" prop="hazardCode">
          <el-select v-model="recordForm.hazardCode" placeholder="请选择重大危险源">
            <el-option
                v-for="dict in dangerList"
                :key="dict.id"
                :label="dict.name"
                :value="dict.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专项任务" prop="taskId" disabled="disabled">
          <el-input v-model="recordForm.taskId" placeholder="请输入专项任务"/>
        </el-form-item>
<!--        <el-form-item label="专项任务" prop="taskId" disabled="disabled">
          <el-select v-model="recordForm.taskId" placeholder="请选择专项检查任务">
            <el-option
                v-for="dict in taskList"
                :key="dict.id"
                :label="dict.taskName"
                :value="dict.id"></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="检查类型" prop="checkType">
          <el-select v-model="recordForm.checkType" placeholder="请选择检查类型" style="width: 100%">
            <el-option v-for="item in checkTypeArr"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="检查日期" prop="checkDate">
          <el-date-picker clearable
                          v-model="recordForm.checkDate"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="请选择检查时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="创建人" prop="creator">
          <el-input v-model="recordForm.creator" placeholder="请输入创建人"/>
        </el-form-item>
        <el-form-item label="是否停产" prop="resultStatus">
          <el-select v-model="recordForm.resultStatus" style="width: 100%">
            <el-option :value="0" label="正常"/>
            <el-option :value="1" label="停产整顿"/>
          </el-select>
        </el-form-item>
        <el-form-item label="数据推送省厅" prop="isTest">
          <el-select v-model="recordForm.isTest" style="width: 100%">
            <el-option :value="0" label="是"/>
            <el-option :value="1" label="否"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRecordForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 添加或修改检查情况记录对话框 -->
    <el-dialog :title="title" :visible.sync="addSpecialDangerFrom" width="800px" append-to-body>
      <el-form ref="form" :model="specialDangerForm" :rules="rules" label-width="150px">
        <el-form-item label="隐患治理" prop="dangerId">
          <el-select v-model="specialDangerForm.dangerId" placeholder="请选择隐患治理">
            <el-option
                v-for="dict in hiddenDangerList"
                :key="dict.id"
                :label="dict.checkParts"
                :value="dict.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专项检查任务编号" prop="taskId">
          <el-input v-model="specialDangerForm.taskId" disabled="disabled"/>
        </el-form-item>
        <el-form-item label="检查类型" prop="checkType">
          <el-select v-model="specialDangerForm.checkType" placeholder="请选择检查类型" style="width: 100%">
            <el-option v-for="item in checkTypeArr"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="检查项编号" prop="checkItemId">
          <el-input v-model="specialDangerForm.checkItemId" disabled="disabled"/>
        </el-form-item>
        <el-form-item label="检查项评分细则编号" prop="checkScoreId">
            <el-input v-model="specialDangerForm.checkScoreId" disabled="disabled"/>
        </el-form-item>
        <el-form-item label="检查日期" prop="checkDate">
          <el-date-picker clearable
                          v-model="specialDangerForm.checkDate"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="请选择检查日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="罚款金额" prop="checkPay">
          <el-input v-model="specialDangerForm.checkPay" placeholder="请输入罚款金额"/>
        </el-form-item>
        <el-form-item label="危害类型" prop="harmType">
          <el-select v-model="specialDangerForm.harmType" placeholder="请选择危害类型" style="width: 100%">
            <el-option :value="1" label="事故类型"/>
            <el-option :value="2" label="火灾隐患"/>
          </el-select>
        </el-form-item>
        <el-form-item label="创建人" prop="creator">
          <el-input v-model="specialDangerForm.creator" placeholder="请输入创建人"/>
        </el-form-item>
        <el-form-item label="数据推送省厅" prop="isTest">
          <el-select v-model="specialDangerForm.isTest" style="width: 100%">
            <el-option :value="0" label="是"/>
            <el-option :value="1" label="否"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitSpecialDangerForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getItem, listTask, getScore, listDangerGovern} from "@/api/specialExamination/task";
import {addRecord, updateRecord} from "@/api/specialExamination/record";
import {hazardInstallationsList} from "@/api/majorHazard";
import {addSpecialDanger, updateSpecialDanger} from "@/api/specialExamination/specialDanger";
export default {
  name: "Task",
  data() {
    return {
      // 显示搜索条件
      showSearch: true,
      total: 0,
      curPage: 1,
      pageSize: 10,
      // 检查任务表格数据
      taskList: [],
      itemList: [],
      scoreList: [],
      dangerList: [],
      hiddenDangerList: [],
      //专项检查情况记录
      record: {},
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open1: false,
      open2: false,
      addRecordFrom:false,
      addSpecialDangerFrom: false,
      checkTypeArr: [
        {label: "企业自查", value: "1"},
        {label: "市级及以下检查", value: "2"},
        {label: "省级检查", value: "3"},
        {label: "部级检查", value: "4"},
      ],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        creator: null,
        deleted: null,
        taskId: null,
        taskName: null,
        taskStartTime: null,
        taskEndTime: null,
        taskTypeName: null,
        taskContent: null,
      },
      // 表单参数
      form: {},
      //专项检查情况记录表单数据
      recordForm: {},

      specialDangerForm: {},
      // 表单校验
      rules: {}
    };
  },
  created() {
    this.getHazardInstallationsList();
    this.getHiddenDangerList();
  },
  methods: {
    // 取消按钮
    pageChange(val) {
      this.curPage = val;
      this.getList();
    },
    /** 查询检查任务列表 */
    getList() {
      this.loading = true;
      listTask(this.queryParams).then(response => {
        this.taskList = response.body.data.data;
        this.total = response.body.cum
      });
    },
    getHazardInstallationsList() {
      hazardInstallationsList().then(res => {
        this.dangerList = res.body.data
      })
    },
    getHiddenDangerList(){
      this.componentsMoudel.startPost('/hiddenGovern/list', {}, true).then(res => {
        this.hiddenDangerList = res.body.data === null ? [] : res.body.data;
      })
     /* listDangerGovern({}).then(res => {
        this.hiddenDangerList = res.body.data;
      })*/
    },
    // 取消按钮
    cancel() {
      this.reset()
      this.addSpecialDangerFrom = false;
      this.addRecordFrom = false;
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.handleQuery();
    },
    reset() {
      this.form = {
        id: null,
        tbBaseCheckTaskId: null,
        taskName: null,
        taskStartTime: null,
        taskEndTime: null,
        taskTypeName: null,
        taskContent: null,
        isDelete: null,
        createDate: null,
        createBy: null,
        updateDate: null,
        updateBy: null
      };
    },
    handleUpdate(row) {
      this.reset()
      getItem(row.taskId).then(response => {
        this.itemList = response.body.data.data;
        this.open1 = true;
        this.title = "检查任务";
      });
    },
    handleCheckscore(row){
      const dt = {}
      dt.taskId = row.taskId
      dt.checkItemId = row.checkItemId
      getScore(dt).then(response => {
        this.scoreList = response.body.data.data;
        this.open2 = true;
        this.title = "评分细则";
      });
    },
    handleAddRecord(row){
      this.recordForm.taskId = row.taskId
      this.addRecordFrom = true
    },
    addSpecialDanger(row){
      this.specialDangerForm.taskId = row.taskId
      this.specialDangerForm.checkItemId = row.checkItemId
      this.specialDangerForm.checkScoreId = row.checkScoreId
      this.addSpecialDangerFrom = true
    },
    submitRecordForm(){
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.recordForm.id != null) {
            updateRecord(this.recordForm).then(response => {
              this.addRecordFrom = false;
            });
          } else {
            addRecord(this.recordForm).then(response => {
              this.addRecordFrom = false;
            });
          }
        }
      });
    },
    submitSpecialDangerForm(){
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.specialDangerForm.id != null) {
            updateSpecialDanger(this.specialDangerForm).then(response => {
              this.addSpecialDangerFrom = false;
            });
          } else {
            addSpecialDanger(this.specialDangerForm).then(response => {
              this.addSpecialDangerFrom = false;
            });
          }
        }
      });
    }
  }
};
</script>
